/** Opciones y display para SearchableMultiSelect de listas UF/lote. */

export const mapUserLotListsToSelectOptions = (userLotLists = []) => (
  userLotLists
    .filter((row) => row?.id)
    .map((row) => ({
      value: row.id,
      label: String(row.name || '').trim() || 'Sin nombre',
    }))
);

export const renderUserLotListSelectValue = (selected, options) => {
  if (!selected.length) return 'Seleccionar listas';

  const names = selected
    .map((id) => options.find((o) => o.value === id)?.label)
    .filter(Boolean);

  if (!names.length) return 'Seleccionar listas';
  if (names.length === 1) return names[0];
  if (names.length === 2) return names.join(' · ');
  return `${names.length} listas asignadas`;
};
